import type { Ref } from "react";
import classNames from "classnames";
import { LiveDot } from "@design-system/LiveDot/LiveDot";
import type { SideNavStatusKind } from "./SideNav.types";
import styles from "./SideNavStatus.module.scss";

const statusLabels: Record<SideNavStatusKind, string | undefined> = {
    unread: "Unread",
    inProgress: "In progress",
    none: undefined,
};

/** 16px status glyph a `SideNavSubItem` draws in its parent's icon column; in progress is a blue `LiveDot`. */
export const SideNavStatus = ({
    status,
    className,
    ref,
}: {
    status: SideNavStatusKind;
    className?: string;
    ref?: Ref<HTMLSpanElement>;
}) => {
    const label = statusLabels[status];

    if (status === "inProgress") {
        return (
            <LiveDot
                ref={ref}
                label={label}
                variant="accent"
                className={className}
            />
        );
    }

    return (
        <span
            ref={ref}
            className={classNames(styles.status, styles[status], className)}
            {...(label === undefined
                ? { "aria-hidden": true }
                : { role: "img", "aria-label": label })}
        />
    );
};
